import { getAgentApi } from '@/gql';
import { Agent } from '@/gql/agent/__generated__/request';
import { useEffect, useState } from 'react';

export interface useAgentInfoResult {
    agentInfo?: Agent;
    loading: boolean;
    error: Error | null;
    refetch: () => Promise<Agent | undefined>;
}

export const useAgentInfo = (uId: string): useAgentInfoResult => {
    const [agentInfo, setAgentInfo] = useState<Agent>();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<Error | null>(null);

    const getAgentInfo = async () => {
        if (!uId) {
            setAgentInfo(undefined);
            return undefined;
        }
        try {
            setLoading(true);
            setError(null);
            const api = getAgentApi();
            const response = await api.agent({ uid: uId });
            if (response?.agent != null) {
                setAgentInfo(response.agent);
                return response.agent;
            } else {
                setAgentInfo(undefined);
                return undefined;
            }
        } catch (err) {
            console.error('Failed to fetch agent info:', err);
            setError(
                err instanceof Error
                    ? err
                    : new Error('Failed to fetch agent info'),
            );
            setAgentInfo(undefined);
            return undefined;
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getAgentInfo();
    }, [uId]);

    return {
        agentInfo,
        loading,
        error,
        refetch: getAgentInfo,
    };
};
